import { render, staticRenderFns } from "./RequestSummery.vue?vue&type=template&id=1390e03a&scoped=true&"
import script from "./RequestSummery.vue?vue&type=script&lang=js&"
export * from "./RequestSummery.vue?vue&type=script&lang=js&"
import style0 from "./RequestSummery.vue?vue&type=style&index=0&id=1390e03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390e03a",
  null
  
)

export default component.exports